// iter 187.k - Annual savings SSoT.
//
// User-facing claim: "2 MONTHS FREE".
// Framing switched from percentage (187.j) to whole-months (187.k) per
// founder call - a "2 months free" claim is more concrete and honest
// than "SAVE 17%", and mathematically conservative:
//
//   Community: 9.99 * 12 = 119.88, minus 99 = 20.88 saved
//              20.88 / 9.99 = 2.09 months  ->  floor = 2 months.
//   Connected: 19.99 * 12 = 239.88, minus 199 = 40.88 saved
//              40.88 / 19.99 = 2.045 months -> floor = 2 months.
//
// Rules:
// - `annualSavingsMonths(tierId)` returns the FLOORED whole months. Never
//   inflates the claim beyond what the math actually earns.
// - Every pricing surface (homepage Pricing section, /pricing, UpgradeWall
//   modal, PortalSubscription, PortalUpgrade) imports from here. A Pytest
//   regression + Playwright screenshot check keep the copy in lockstep.
// - Do NOT hardcode "2 months" anywhere else - always call
//   formatSavingsBadge() or formatPerCardSavings().

import { TIERS } from './tiers';

/**
 * Whole months earned by choosing annual over monthly.
 * Floored so the stated number is always conservative relative to
 * the actual savings. Returns 0 if the tier has no annual price.
 */
export const annualSavingsMonths = (tierId) => {
  const t = TIERS[tierId];
  if (!t || !t.price || !t.priceAnnual) return 0;
  const yearlyIfMonthly = t.price * 12;
  const savings = yearlyIfMonthly - t.priceAnnual;
  if (savings <= 0) return 0;
  return Math.floor(savings / t.price);
};

/**
 * Maximum months-free across subscription tiers - powers the
 * "2 MONTHS FREE" pill on the Monthly/Annual toggle.
 */
export const maxAnnualSavingsMonths = () => {
  const subTiers = ['community', 'connected'];
  return Math.max(0, ...subTiers.map(annualSavingsMonths));
};

/** Copy used inside the ANNUAL toggle pill. */
export const formatSavingsBadge = () => {
  const months = maxAnnualSavingsMonths();
  return months > 0 ? `${months} MONTHS FREE` : '';
};

/** Copy used under each subscription card when ANNUAL is active. */
export const formatPerCardSavings = (tierId) => {
  const months = annualSavingsMonths(tierId);
  return months > 0 ? `${months} months free vs monthly` : '';
};
